import { render } from "./FeaturePanel.vue?vue&type=template&id=27cd3ad4&scoped=true"
import script from "./FeaturePanel.vue?vue&type=script&lang=ts"
export * from "./FeaturePanel.vue?vue&type=script&lang=ts"

import "./FeaturePanel.vue?vue&type=style&index=0&id=27cd3ad4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27cd3ad4"

export default script